
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soccer/team/[id]",
      function () {
        return require("private-next-pages/soccer/team/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soccer/team/[id]"])
      });
    }
  